import { SearchIcon } from "@heroicons/react/solid";
import { useTranslation } from "react-i18next";
import ContactList from "../contact/ContactList";
import ChatCard from "./chat-card/ChatCard";
import { ApiResponse } from "../../api/apiResponse";
import toast from "react-hot-toast";
import { getContacts } from "../../api/endpoints/chat/conversations";
import { AuthContextInterface, useAuth } from "../../context/AuthContext";
import { useEffect, useState } from "react";
import useSearch from "../../hooks/useSearch";
import useSearchParticipant from "../../hooks/useSearchParticipant";
import ConversationModel from "../../api/models/ConversationModel";
import { Conversation } from "@chatscope/use-chat";

type ChatListContainerProps = {
  userList: Conversation<ConversationModel>[];
  getUser: any;
  setActiveConversation: any;
  activeConversation: any;
  setShowContactList: () => void;
  refetchConversations: () => void;
};

export default function ChatListContainer(props: ChatListContainerProps) {
  const {
    userList,
    setActiveConversation,
    activeConversation,
    setShowContactList,
    refetchConversations,
  } = props;
  const [participantListData, setParticipantListData] =
    useState<Conversation<ConversationModel>[]>(userList);

  const LocalBasePath = "page.chat";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  const { currentUser }: AuthContextInterface = useAuth()!;
  const [contactList, setContactsList] = useState([]);
  const [contactListCopy, setContactsListCopy] = useState([]);

  const { onSearch } = useSearch();
  const { onSearch: onSearchParticipant } = useSearchParticipant();

  const getContactsList = async () => {
    const response: ApiResponse = await getContacts({
      ActorId: currentUser?.id,
      ActorType: currentUser?.object_type,
    });
    if (response.isSuccess) {
      const { data } = response;
      setContactsList(data ?? []);
      setContactsListCopy(data ?? []);
    } else {
      response.errorMessages.forEach((errorMessage) => {
        toast.error(errorMessage);
      });
    }
  };

  useEffect(() => {
    if (currentUser?.object_type?.toLowerCase() !== "candidate") {
      getContactsList();
    }
  }, []);

  useEffect(() => {
    if (!!userList) {
      setParticipantListData(userList);
    }
  }, [userList]);

  const searchParticipants = (val: string) => {
    let dataContacts = onSearch(val, contactListCopy);
    let dataParticipants = onSearchParticipant(val, userList);
    setContactsList(dataContacts);
    setParticipantListData(dataParticipants);
  };

  return (
    <div className="w-full h-full bg-white overflow-y-auto">
      {/* <div className="sticky top-0 z-20 bg-white flex flex-col gap-[18px] px-[21px] py-7  ">
        <h2 className="text-lg leading-6 font-medium text-gray-900">
          {t("messages")}
        </h2>
        <div className="relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 start-0 ps-3  flex items-center pointer-events-none">
            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            className="block w-full ps-10 border border-gray-300 focus:ring-brandblue-500 focus:border-brandblue-500 text-sm rounded-md"
            placeholder={t("searchByName")}
            onChange={(e) => {
              searchParticipants(e.target.value);
            }}
          />
        </div>
      </div>
      <div className="w-full flex flex-col">
        <h3 className="z-10   border-t border-b border-gray-300 bg-gray-100 px-6 py-2 flex justify-between	 text-xs  text-gray-900">
          <span>{t("conversations")}</span>
          <span>{participantListData?.length}</span>
        </h3>
        <div className="w-full">
          {participantListData.map(
            (conversation: Conversation<ConversationModel>) => {
              // Helper for getting the data of the first participant
              const receiver = conversation.data!.getReceiverParticipant(
                currentUser!.twilioIdentity!
              );
              return (
                <ChatCard
                  message={""}
                  conversationId={conversation.data!.twilioId}
                  senderName={receiver.user.fullNameWithoutMiddle!}
                  senderType={receiver.user.object_type!.toLowerCase()}
                  key={conversation.id}
                  active={activeConversation?.id === conversation.id}
                  unreadMessages={conversation.unreadCounter}
                  senderImage={receiver.user.profile_picture_url}
                  onClick={(e) => {
                    setActiveConversation(conversation?.id, true);
                    setShowContactList();
                  }}
                />
              );
            }
          )}
        </div>
      </div>
      <div className="w-full flex flex-col ">
        <div className="z-10 sticky  border-t border-b border-gray-300 bg-gray-100 px-6 py-2 flex justify-between	 text-xs  text-gray-900">
          <h3>{t("contacts")}</h3>
          <h3>{contactList?.length}</h3>
        </div>
        <ContactList
          contactList={contactList}
          refetchContactList={getContactsList}
          refetchConversations={refetchConversations}
        />
      </div> */}
    </div>
  );
}
